module.exports = __webpack_public_path__ + "img/O2O-pic-02.16cb676b.png";